import { useState, React } from 'react'
import { Zoom, Fade } from 'react-awesome-reveal'
import dsc from '../media/DSC.png'
import scr from '../media/SCR.png'
import sugarcosmetics from '../media/sugarcosmetics.png'
import rfp from '../media/RFP.png'
import coschedule from '../media/coschedule.png'
import freshly from '../media/freshly.png'
import Container from 'react-bootstrap/esm/Container'
import Button from 'react-bootstrap/esm/Button'
import Row from 'react-bootstrap/esm/Row'
import Col from 'react-bootstrap/esm/Col'
import Card from 'react-bootstrap/esm/Card'
import Modal from 'react-bootstrap/Modal'

const Experience = ({darkMode}) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div data-theme={darkMode ? "dark" : "light"}>
            <br></br>
            <Fade>
            <Container>
                <br></br>
                <h2 className="lead" align="center"><b>- Projects -</b></h2>
                <br></br>
                <Zoom>
                <Row>
                    <Col lg={4} sm={12}>
                        <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                        <br></br>
                        <center>
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div className="flip-card-front">
                                        <Card.Img variant="top" src={freshly}/>
                                        <Card.Body>
                                            <Card.Title align="center">Freshly Website</Card.Title>
                                            <Card.Text>
                                                <p align="center">A Clone of US based online meal delivering website.</p>
                                            </Card.Text>
                                        </Card.Body>
                                    </div>
                                    <div className="flip-card-back">
                                        <p>A web Application to deliver Meals on daily basis
                                        <br></br>Incorporated authentication to signin, login pages and payment pages.
                                        <br></br>Implemented with sorting and filter functionality.
                                        </p>
                                    </div> 
                                </div>
                            </div>
                        </center>
                        <br></br>
                        <div>
                            <a href="https://warm-strudel-e018b6.netlify.app/" target="_blank" rel="noreferrer noopener">
                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Project</Button>
                            </a>
                            <a href="https://github.com/Pratik8279/FreshlyCloning" target="_blank" rel="noreferrer noopener">
                            <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                            </a>
                        </div>
                        <br></br>
                        </Card>
                    </Col>
                    <Col lg={4} sm={12}>
                        <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                        <br></br>
                        <center>
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div className="flip-card-front">
                                        <Card.Img variant="top" src={sugarcosmetics}/>
                                        <Card.Body>
                                            <Card.Title align="center">Sugarcosmetics.com</Card.Title>
                                            <Card.Text>
                                                <p align="center">A Clone of Skin and healthcare products delivering Website.</p>
                                            </Card.Text>
                                        </Card.Body>
                                    </div>
                                    <div className="flip-card-back">
                                        <p>Clone of Ecommerce website called SugarCosmetics
                                        <br></br> Sign-up/log-in with Authentication 
                                        <br></br> Menu Page ,Cart Page ,Payment Page
                                        <br></br> Sorting and Filtering Functionalities
                                        </p>
                                    </div> 
                                </div>
                            </div>
                        </center>
                        <br></br>
                        <div>   
                 
                            <a href="https://moonlit-stroopwafel-a95b2b.netlify.app/" target="_blank" rel="noreferrer noopener">
                            <Button variant={darkMode ? "outline-light" : "outline-dark"}  className="sbtn">View Project</Button>
                            </a>
                            <a href="https://github.com/Pratik8279/sugarcosmetics-app-clone" target="_blank" rel="noreferrer noopener">
                                <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                            </a>
                        </div>
                        <br></br>
                        </Card>
                    </Col>
                    <Col lg={4} sm={12}>
                        <Card align="center" className="exp" data-theme={darkMode ? "dark" : "light"}>
                        <br></br>
                        <center>
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div className="flip-card-front">
                                        <Card.Img variant="top" src={coschedule}/>
                                        <Card.Body>
                                            <Card.Title align="center">Coschedule.com</Card.Title>
                                            <Card.Text>
                                                <p align="center">Coschedule is a all in one platform for planning,organizing,and executing all the things related to event management </p>
                                            </Card.Text>
                                        </Card.Body>
                                    </div>
                                    <div className="flip-card-back">
                                        <p>1. Sign-in functionality with authentication 2. frontend architecture of website 3. tracking of tasks related to your project on the basis of day 4. calendar representation of all the tasks of projects
                                        <br></br>Created JSON servers for creating APIs.
                                        <br></br>Tech Stack - React.js, Redux.
                                        </p>
                                    </div> 
                                </div>
                            </div>
                        </center>
                        <br></br>
                        <div>
                            <a href="https://musical-taiyaki-dd65c8.netlify.app/" target="_blank" rel="noreferrer noopener">
                                <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Project</Button>
                            </a>
                            <a href="https://github.com/Pratik8279/Clone-of-coschedule.com" target="_blank" rel="noreferrer noopener">
                                <Button variant={darkMode ? "outline-light" : "outline-dark"} className="sbtn">View Github Repo</Button>
                            </a>
                        </div>
                        <br></br>
                        </Card>
                    </Col>
                </Row>
                </Zoom>
                <br></br>
              
            </Container>
            </Fade>
            <br></br>
            <hr></hr>
            <br></br>
        </div>
    )
}

export default Experience
